import React from 'react';
import PropTypes from 'prop-types';

import Popup from 'components/Popup';

export default function SaleDayPopup({ isPopupOpen, setIsPopupOpen }) {
  const closePopup = () => setIsPopupOpen(false);

  return (
    isPopupOpen && (
      <Popup closePopup={closePopup}>
        <h2 className='mb-4'>What is a same day sale?</h2>
        <p>
          What is a same day sale? A same day sale (aka cashless exercise) provides employees the funds to exercise their options using
          short-terms provided by brokerage firms.
        </p>
      </Popup>
    )
  );
}

SaleDayPopup.propTypes = {
  isPopupOpen: PropTypes.bool,
  setIsPopupOpen: PropTypes.func
};
